var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 108,
    viewBox: "0 0 120 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 89.2732L30.5001 54.7732L89.5 1.77322C92 -0.226807 101.5 -0.726813 103.5 1.27322L118.5 17.2732C120 18.7732 120.5 28.7732 117 32.2732L65 89.2732Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 94.2732L25.0001 59.7732C19.5 65.2732 19.9923 71.7271 20.5 74.7732C21 77.7732 21.5 80.2732 20.0001 82.2732L37 99.2732C38.1667 98.6065 42.5 97.7732 45.5 98.7732C48.5 99.7732 55.5 98.2732 59.5 94.2732Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5001 103.773L15.5 87.7732L1.50005 101.273C0 102.773 0 103.773 0 104.773C0 105.773 1.5 107.773 3.00005 107.773H27.5001L31.5001 103.773Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 104.273C60.5 102.34 62.067 100.773 64 100.773H98C99.933 100.773 101.5 102.34 101.5 104.273C101.5 106.206 99.933 107.773 98 107.773H64C62.067 107.773 60.5 106.206 60.5 104.273Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.397282b487d9dcdfec4dc5ee97d07c98.svg";
export { ForwardRef as ReactComponent };